<template>
  <div style="padding-right: 1.5em; position: relative;">
    <div v-for="(val, index) in value" style="position: relative;padding-left: 1.5em;overflow:auto;margin-bottom:1em;">
      <item :item="item" v-model="value[index]" :defaultValue="val" :id="id + index" />
      <font-awesome-icon icon="minus" v-if="value.length > 1 && value.length > item.minLength" style="position: absolute;left:0;top:12px;cursor:pointer;" v-on:click="removeField(index)"/>
    </div>
    <a href="#" v-if="value.length < item.maxLength" v-on:click.prevent="addField(item, $event)">
      <font-awesome-icon icon="plus" style="position: absolute;right:0;bottom:28px;"/>
    </a>
  </div>
</template>

<script>
import Item from './Item.vue'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import '@fortawesome/fontawesome/styles.css';
import fontawesome from '@fortawesome/fontawesome';
import { faPlus, faMinus } from '@fortawesome/fontawesome-free-solid';

fontawesome.config = {
  autoAddCss: false,
};

fontawesome.library.add(faPlus);
fontawesome.library.add(faMinus);

export default {
  name: 'Configuration',
  components: {
    Item,
    FontAwesomeIcon
  },
  props: ['item', 'defaultValue', 'id'],
  methods: {
    getFormName(type, index){
      return `${type}-${index}`
    },
    addField(item, e){
      e.preventDefault();
      let placeholderValue = null;
      if(item.type == 'object') {
        placeholderValue = {};
        placeholderValue = JSON.parse(JSON.stringify(this.item.default));
      }
      this.value.push(placeholderValue);
    },
    removeField(index){
      this.value = this.value.slice(0, index).concat(this.value.slice(index+1));
    }
  },
  mounted () {
      // respect the minlength of the array
      if (this.value.length < this.item.minLength) {
        for (var i = this.value.length; i < this.item.minLength; i++) {
          let placeholderValue = null;
          if(this.item.type == 'object') {
            placeholderValue = {};
            placeholderValue = JSON.parse(JSON.stringify(this.item.default));
          }
          this.value.push(placeholderValue);
        }
      }
  },
  data () {
    let value = this.defaultValue;

    if(!Array.isArray(value) && value){
      value = [value];
    } else if(Array.isArray(value)){

    } else {
      value = [];
    }

    let obj = {
      value
    }

    return obj;
  },
  watch: {
    value(newVal){
      this.$emit('input', newVal);
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/configurator/ArrayItem.vue